module.exports = __webpack_public_path__ + "img/ico_directory.433f182b.svg";